import { CensusFileRowStatusEnum } from '../api/enums/census-file-row-status.enum'
import { CensusFileRowTypeEnum } from '../api/enums/census-file-row-type.enum'

const typeLabels: Partial<Record<CensusFileRowTypeEnum, string>> = {
  [CensusFileRowTypeEnum.DRAFT_EMPLOYEE]: 'New',
  [CensusFileRowTypeEnum.DUPLICATE_EMPLOYEE]: 'Duplicate',
  [CensusFileRowTypeEnum.UPDATE_EMPLOYEE_BENEFITS]: 'Update w/Benefits',
  [CensusFileRowTypeEnum.UPDATE_EMPLOYEE_NO_BENEFITS]: 'Update No Benefits',
}

const formatEnumLabel = (value: string) =>
  value
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

export const formatCensusFileRowTypeLabel = (
  type?: string,
  status?: CensusFileRowStatusEnum
) => {
  if (!type) return ''

  if (
    type === CensusFileRowTypeEnum.DRAFT_EMPLOYEE &&
    status === CensusFileRowStatusEnum.COMPLETE
  ) {
    return 'Created'
  }

  return typeLabels[type as CensusFileRowTypeEnum] ?? formatEnumLabel(type)
}
